/**
 * DetailViewerContainer
 * --
 */
import React from 'react';
import DetailViewerPresenter from './DetailViewerPresenter';
import { useParams } from 'react-router-dom';
import { decrypt } from 'utils/Crypto';
import { useGetNotice } from 'hooks/NoticeHooks';
import { useGetEvent } from 'hooks/EventHooks';

const DetailViewerContainer = (props) => {
  /* ===== ROUTE ===== */
  const { detailId } = useParams();

  // 상세 조회 idx
  const detailIdx = React.useMemo(() => {
    if (!detailId) return null;

    const decodeIdx = decrypt(decodeURIComponent(detailId));

    return Number(decodeIdx);
  }, [detailId]);

  /* ===== PROPS ===== */
  const { type = 'notice', screenSize } = props;

  /* ===== Data ===== */
  const options = {
    initialData: null,
    select: (res) => {
      const { status, data } = res;

      if (status !== 200) return null;

      return data;
    },
  };
  // 공지사항 상세 데이터 조회
  const { data: Notice } = useGetNotice(detailIdx, null, {
    ...options,
    enabled: type === 'notice' && detailIdx ? true : false,
  });
  // 이벤트 상세 데이터 조회
  const { data: Event } = useGetEvent(detailIdx, null, {
    ...options,
    enabled: type === 'event' && detailIdx ? true : false,
  });

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  const DetailData = React.useMemo(() => {
    if (!Notice && !Event) return null;

    const standard = {
      notice: Notice,
      event: Event,
    };

    return {
      key: standard[type][`${type}_id`],
      title: standard[type][type === 'notice' ? 'notice_name' : 'event_title'],
      content: standard[type][`${type}_content`],
      created: standard[type][`created_at`],
      updated: standard[type][`updated_at`],
      type: type,
      start: standard[type].start_date,
      end: standard[type].end_date,
    };
  }, [Notice, Event, type]);

  /* ===== RENDER ===== */
  return (
    <>
      <DetailViewerPresenter data={DetailData} screenSize={screenSize} />
    </>
  );
};

export default DetailViewerContainer;
